<div class="card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Message History</div>
	</div>
	<p-divider></p-divider>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="timecardIdHistory"
		[loading]="!timecardIdHistory"
		[globalFilterFields]="app.keys(timecardIdHistory)"
		[rowHover]="true"
		[rows]="10"
		[showCurrentPageReport]="true"
		[rowsPerPageOptions]="[10, 25, 50]"
		responsiveLayout="scroll"
		[paginator]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} messages sent"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="timecard.employee.nickName">
					<div class="d-flex w-100">
						Employee
						<p-sortIcon field="field"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter
								field="timecard.employee.nickName"
								matchMode="equals"
								display="menu"
								[showMatchModes]="false"
								[showOperator]="false"
								[showAddButton]="false"
								class="ml-auto"
							>
								<ng-template pTemplate="header">
									<div class="px-3 pt-3 pb-0">
										<span class="font-bold">Employee</span>
									</div>
								</ng-template>
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-multiSelect
										[ngModel]="value"
										[options]="receivedEmployeeList"
										optionValue="value"
										optionLabel="label"
										placeholder="Any"
										(onChange)="filter($event.value)"
									>
										<ng-template let-option pTemplate="item">
											<div class="p-multiselect-representative-option">
												<fa-icon [icon]="['far', option.meta]" class="me-2" size="lg"></fa-icon>
												<span class="ml-1">{{ option.label }}</span>
											</div>
										</ng-template>
									</p-multiSelect>
								</ng-template>
							</p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="datetime">
					<div class="d-flex w-100">
						Sent Date
						<p-sortIcon field="datetime"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="datetime" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="timeIn">
					<div class="d-flex w-100">
						In / Out Time
						<p-sortIcon field="timeCard."></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="field" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="timecard.totalTime">
					<div class="d-flex w-100">
						Total Hours Worked
						<p-sortIcon field="timecard.totalTime"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="numeric" field="timecard.totalTime" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr>
				<td>{{ rec.timecard.employee.nickName }}</td>
				<td>{{ app.moment(rec.datetime).format('L LT') }}</td>
				<td>
					{{ app.moment(rec.timecard.timeIn).format('L LT') }} -
					<span *ngIf="!rec.timecard.timeOut">still clocked in</span>
					<span *ngIf="rec.timecard.timeOut">{{ app.moment(rec.timecard.timeOut).format('L LT') }}</span>
				</td>
				<td>{{ rec.timecard.totalTime }}</td>
			</tr>
		</ng-template>
	</p-table>
</div>
